import { render, staticRenderFns } from "./homeMobile.vue?vue&type=template&id=67b4ccd6"
import script from "./homeMobile.vue?vue&type=script&lang=js"
export * from "./homeMobile.vue?vue&type=script&lang=js"
import style0 from "./homeMobile.vue?vue&type=style&index=0&id=67b4ccd6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports